import { useState, useEffect } from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import HomePage from './pages/HomePage/HomePage';
import LoginPage from './pages/LoginPage/LoginPage';
import UsersPage from './pages/UsersPage/UsersPage';
import ServersPage from './pages/ServersPage/ServersPage';
import TransactionPage from './pages/TransactionPage/TransactionPage';
import PlansPage from './pages/PlansPage/PlansPage';
// import PromotionsPage from './pages/PromotionsPage/PromotionsPage';
import SessionsPage from './pages/SessionsPage/SessionsPage';
import RefLinksPage from './pages/RefLinksPage/RefLinksPage';
import AffiliatePage from './pages/AffiliatePage/AffiliatePage';
import NavBar from './components/NavBar/NavBar';
import { getToken, logout } from './api/client/client.js';
import { getMe } from './api/authAPI/authAPI.js';
import useLang from './hooks/use-lang/useLang.js';
import './index.css';

export default function App() {
  const { t } = useLang();
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentPage, setCurrentPage] = useState('Dashboard');

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setAuthChecked(true);
      return;
    }

    getMe()
      .then(() => setIsAuthenticated(true))
      .catch(() => {
        logout();
        setIsAuthenticated(false);
      })
      .finally(() => setAuthChecked(true));
  }, []);

  function handleLogout() {
    logout();
    setIsAuthenticated(false);
    setCurrentPage('Dashboard');
  }

  if (!authChecked) {
    return <div className="app-loading">{t('common.loading')}</div>;
  }

  if (!isAuthenticated) {
    return <LoginPage onLogin={() => setIsAuthenticated(true)} />;
  }

  const PAGES = {
    Users: UsersPage,
    'Active Servers': ServersPage,
    Transactions: TransactionPage,
    Plans: PlansPage,
    'Active Sessions': SessionsPage,
    'Ref Links': RefLinksPage,
    Affiliate: AffiliatePage,
  };
  const Page = PAGES[currentPage] || HomePage;

  return (
    <>
      <NavBar onNavigate={setCurrentPage} onLogout={handleLogout} currentPage={currentPage} />
      <Page onNavigate={setCurrentPage} onLogout={handleLogout} />
    </>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
